import { useNavigate } from 'react-router-dom';

import usePinsAccount from '@/hooks/usePinsAccount';
import useToast from '@/hooks/useToast';
import ROUTES from '@/router/routes';
import {
  // getTokenizadasConTimeout, // TOKENIZADAS: deshabilitado temporalmente por problemas con el proveedor de pagos.
  getTransaccionesPendientes,
} from '@/services/myAccount';
import { ResponseTarjetasTokenizadas } from '@/types/myAccount';
import {
  // CARD_MAPPER, // TOKENIZADAS: deshabilitado temporalmente por problemas con el proveedor de pagos.
  CardKey,
  CONF_TARJETAS,
  isApiError,
} from '@/utils';

export const useHandleTransaction = () => {
  const toast = useToast();
  const { pinsData, updatePinsData } = usePinsAccount();
  const navigate = useNavigate();

  const handleContinue = async (selectedCard: CardKey) => {
    const hasInstallments =
      (pinsData.selectedProduct?.tipoProductoCuotaPrecioTO?.length ?? 0) > 0;

    const isDebit = CONF_TARJETAS[selectedCard].debito;

    const mode = hasInstallments && !isDebit ? 'INSTALLMENTS' : 'ONE_PAYMENT';

    updatePinsData({ loadingTokenized: true });

    // TOKENIZADAS: deshabilitado temporalmente por problemas con el proveedor de pagos.
    // const cardKey = CARD_MAPPER[selectedCard];
    // const tokenizedResponse = (await getTokenizadasConTimeout(
    //   cardKey
    // )) as ResponseTarjetasTokenizadas;
    const tokenizedResponse: ResponseTarjetasTokenizadas = { tokenizadas: [] };

    updatePinsData({
      responseTokenizedCards: tokenizedResponse,
      loadingTokenized: false,
    });

    const hasTokenized =
      tokenizedResponse?.tokenizadas &&
      tokenizedResponse?.tokenizadas?.length > 0 &&
      !tokenizedResponse.warning;

    // compra en cuotas
    if (mode === 'INSTALLMENTS' && !pinsData.showModalPayInInstallments) {
      updatePinsData({
        showModalPayInInstallments: true,
        selectedPaymentMethod: undefined,
        showPaymentModalMethod: false,
      });
      return;
    }

    // compra en un pago
    if (
      mode === 'ONE_PAYMENT' &&
      !pinsData.showModalPayInOneInstallment &&
      hasTokenized
    ) {
      updatePinsData({
        showModalPayInOneInstallment: true,
        selectedPaymentMethod: undefined,
        showPaymentModalMethod: false,
      });
      return;
    }

    // redirect a formulario de pago
    updatePinsData({ selectedCard });
    navigate(ROUTES.paymentForm, { replace: false });
  };

  const handleTransactionValidation = async (
    selectedCard: CardKey,
    skipValidation = false
  ) => {
    const resp = await getTransaccionesPendientes();

    if (isApiError(resp)) {
      // estado false. No se espera un error acÃ¡. continÃºo (que falle en el siguiente paso).
      return false;
    }

    if (resp.blacklist) {
      toast.show(resp.blacklist_msg);
      return false;
    }

    let msgConfirm = '';
    if (!skipValidation) {
      if (resp.minTrxAnterior !== undefined && resp.minTrxAnterior === 0) {
        msgConfirm =
          'Tu última transacción exitosa fue hace 1 minuto. ¿Querés continuar de todos modos?';
      } else if ((resp.minTrxAnterior || -1) === 1) {
        msgConfirm =
          'Tu última transacción exitosa fue hace ' +
          resp.minTrxAnterior +
          ' minuto. ¿Querés continuar de todos modos?';
      } else if ((resp.minTrxAnterior || -1) > 1) {
        msgConfirm =
          'Tu última transacción exitosa fue hace ' +
          resp.minTrxAnterior +
          ' minutos. ¿Querés continuar de todos modos?';
      } else if ((resp.minsRestantes || -1) === 1) {
        msgConfirm =
          'Tenés una transacción en procesamiento, esperá ' +
          resp.minsRestantes +
          ' minuto y volvé a chequear tus movimientos. ¿Querés continuar de todos modos?';
      } else if ((resp.minsRestantes || -1) > 1) {
        msgConfirm =
          'Tenés una transacción en procesamiento, esperá ' +
          resp.minsRestantes +
          ' minutos y volvé a chequear tus movimientos. ¿Querés continuar de todos modos?';
      }
    }

    if (
      msgConfirm === '' ||
      pinsData?.statusTransaction?.status === 'success'
    ) {
      updatePinsData({
        showModalPayInInstallments: false,
        showModalPayInOneInstallment: false,
        statusTransaction: { status: null, msg: undefined },
      });
      handleContinue(selectedCard);
    } else {
      updatePinsData({
        showModalWallet: false,
        showPaymentModalMethod: false,
        showWalletLoadModal: false,
        statusTransaction: { status: 'error', msg: msgConfirm },
      });
    }
  };

  return { handleTransactionValidation };
};
